import { BaseSettingsScreen } from '../screen/BaseSettingsScreen';

export class AlertsEntity extends BaseSettingsScreen {
  readonly type = 'alerts';
}
